import React from 'react';
import { FileSearch, Code2, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-700 font-medium mb-4 block">{t.services.subtitle}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">{t.services.title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.services.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Study & Planning */}
          <div className="group relative bg-white rounded-3xl p-8 lg:p-10 border border-gray-200 hover:border-amber-300 hover:shadow-xl transition-all duration-500">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <FileSearch className="w-8 h-8 text-amber-700" />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{t.services.study.title}</h3>
                <ul className="space-y-3">
                  {t.services.study.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Analysis & Development */}
          <div className="group relative bg-white rounded-3xl p-8 lg:p-10 border border-gray-200 hover:border-gray-400 hover:shadow-xl transition-all duration-500">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 rounded-2xl bg-gray-200 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                <Code2 className="w-8 h-8 text-gray-700" />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">{t.services.analysis.title}</h3>
                <ul className="space-y-3">
                  {t.services.analysis.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle2 className="w-5 h-5 text-gray-500 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;